export function TagChip({ children, active = false, onClick }: { children: React.ReactNode; active?: boolean; onClick?: () => void }) {
  return (
    <span
      onClick={onClick}
      className={
        "inline-flex cursor-pointer items-center rounded-full border px-3 py-1 text-xs font-medium transition active:scale-[0.97] " +
        (active
          ? "border-stone-900 bg-stone-900 text-white"
          : "border-stone-200 bg-white text-stone-600 hover:border-stone-300 hover:bg-stone-50")
      }
      data-testid={`tag-chip-${children}`}
    >
      {children}
    </span>
  );
}
